import { Theme } from "@mui/material";

const campaignStyles = (theme: Theme) => {
  return {
    borderedBox: {
      border: "1px solid #47556940",
      borderRadius: "8px",
      padding: 1,
    },
    styledButton: {
      height: "38px",
      minwidth: "200px",
    },
    centeredBox: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center" /* Horizontally center */,
      alignItems: "center" /* Vertically center */,
      margin: 0,
    },
    dropDownMenuItem: {
      fontSize: "14px",
      "&:not(:last-child)": {
        borderBottom: "1px solid #e0e0e0",
      },
      "&.Mui-selected": {
        backgroundColor: "#FFFFFF",
        color: theme.palette.primary.main,
        fontWeight: 500,
      },
      "&:focus": { backgroundColor: "#FFFFFF" },
    },
    stackLine: {
      borderBottom: "1px dashed #B9BABB",
      cursor: "pointer",
    },
  };
};

export default campaignStyles;
